import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epFormSelectionMethod',
    standalone: false
})
export class FormSelectionMethodPipe implements PipeTransform {
    transform(value: string): string {
        let desc = '';
        if (!value) {
            return desc;
        }

        switch (value) {
            case 'D':
                desc = 'Default';
                break;
            case 'M':
                desc = 'Mandatory';
                break;
            case 'O':
                desc = 'Optional';
                break;
            case 'S':
                desc = 'Additional';
                break;
        }

        return desc;
    }
}
